/* eslint-disable react/prop-types */
import React from 'react';
import PageHeader from '../../TemplateSections/PageHeader/PageHeader';
import PageFooter from '../../TemplateSections/PageFooter/PageFooter';
import PageBody from '../../TemplateSections/PageBody/PageBody';
import PageWrapper from '../../TemplateSections/PageWrapper/PageWrapper';

const OneColumnLayout = ({
    children,
    pageName,
    overrideHeader,
    overrideFooter
}) => (
    <PageWrapper pageName={pageName}>
        <PageHeader customHeader={overrideHeader} />
        <PageBody>
            <div className="vx_row">
                <div className="vx_col-xs-12">
                    {children}
                </div>
            </div>
        </PageBody>
        <PageFooter customFooter={overrideFooter} />
    </PageWrapper>
);

export default OneColumnLayout;
